module.exports = "/packs/images/products/subscription-calendar-8b8fbff51e89401562b149681d3a88e2.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/subscription-calendar.png
// module id = 1807
// module chunks = 0